module.exports = __webpack_public_path__ + "img/pen-field.f0109d20.svg";